import { createSlice } from '@reduxjs/toolkit';
import { OrderExpeditionPackagesGridStateType } from 'src/types/orderExpeditionPackagesGrid';

const initialState: OrderExpeditionPackagesGridStateType = {
    data: null,
    loading: false,
    error: false,
};
export const orderExpeditionPackagesGridSlice = createSlice({
    name: 'orderExpeditionPackagesGrid',
    initialState,
    reducers: {
        getOrderExpeditionPackagesGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getOrderExpeditionPackagesGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getOrderExpeditionPackagesGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getOrderExpeditionPackagesGridFetch,
    getOrderExpeditionPackagesGridFetchSuccess,
    getOrderExpeditionPackagesGridFetchFailure,
} = orderExpeditionPackagesGridSlice.actions;

export default orderExpeditionPackagesGridSlice.reducer;
